import React from 'react';
import BBCode from './bbcode';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './copybox.css';

export default class CopyBox extends React.Component {
	//static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			hover: false,
			id: this.makeId(),
			copied: false,
		};
		this.makeId = this.makeId.bind(this);
		this.hover = this.hover.bind(this);
		this.copy = this.copy.bind(this);
		this.hide = this.hide.bind(this);
  };

	componentDidMount() {
  }

	makeId() {
		let ID = "";
		let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
		for ( var i = 0; i < 12; i++ ) {
			ID += characters.charAt(Math.floor(Math.random() * 36));
		}
		return ID;
	}

	hover(hover) {
		this.setState({hover});
	}

	hide() {
		this.setState({copied: false});
	}

	copy() {
		var text = document.getElementById("copybox-"+this.state.id);
    var selection = window.getSelection();
    var range = document.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
    //add to clipboard.
    document.execCommand('copy');
		this.setState({copied: true});
	}

  render() {
    return (
			<div className="code-box" style={{position: 'relative'}} onMouseEnter={()=>this.hover(true)} onMouseLeave={()=>this.hover(false)}>
				<span id={"copybox-"+this.state.id}><BBCode text={this.props.content} /></span>
				{//this.state.hover===true &&
					<OverlayTrigger
						placement="bottom"
						overlay={<Tooltip id="button-copy-rtmp-address">{this.state.copied?<>Text Copied <FontAwesomeIcon icon="check" style={{color: '#00ff00'}} /></>:<>Copy Text</>}</Tooltip>}
					>
					<button className="button-code-copy" onClick={this.copy} onMouseLeave={this.hide}><FontAwesomeIcon icon="copy" style={{color: this.state.hover===true?'rgb(var(--success-rgb))':'#000000'}} /></button>
					</OverlayTrigger>
				}
			</div>
		);
	}
}
